export class AccountType {
    AccountTypeID: number;
    AccountTypeName: string;
    AccountTypeDescription: string;
    IsActive: boolean = true;
    ModifiedBy : number;

}